import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G fill="#414141">
        <Path d="M6.57 3.262a.776.776 0 00-1.14 0L3.18 5.887a.75.75 0 001.14.976l.93-1.086v6.973a.75.75 0 001.5 0V5.777l.93 1.086a.75.75 0 101.14-.976L6.57 3.262zM14.738 11.056a.75.75 0 00-1.057.08l-.931 1.087V5.25a.75.75 0 10-1.5 0v6.973l-.93-1.086a.748.748 0 00-1.239.149.75.75 0 00.1.827l2.25 2.625a.751.751 0 001.139 0l2.25-2.625a.75.75 0 00-.082-1.057z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
